import React, { useContext, useState } from 'react';
import AuthContext from '../context/AuthContext';
import OrgSelect from '../components/admin/OrgSelect';
import OrgDashboard from '../components/admin/OrgDashboard';

// Hooks
import { useUsers } from '../hooks/useUsers';
import { useOrganizations } from '../hooks/useOrganizations';

const AdminPortal = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const { users, addUser, loading: usersLoading } = useUsers(user, authLoading);
  const { organizations, fetchOrganizations } = useOrganizations(user, authLoading);
  const [selectedOrg, setSelectedOrg] = useState(null);

  if (authLoading) return <div className="p-5 text-center"><i className="fas fa-spinner fa-spin mr-2"></i>Loading Admin Portal...</div>;
  if (user?.type !== 'admin') return <div className="p-5 text-center alert alert-danger">Access Denied: Administrator role required.</div>;

  // Refresh active organization details if list reloads
  const activeOrg = selectedOrg ? organizations.find(o => o._id === selectedOrg._id) || selectedOrg : null;

  return (
    <div className="admin-portal p-3">
      {activeOrg ? (
        <OrgDashboard 
          org={activeOrg} 
          onBack={() => setSelectedOrg(null)} 
          users={users}
          fetchOrganizations={fetchOrganizations}
          addUser={addUser}
          usersLoading={usersLoading}
        />
      ) : (
        <div>
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <h1>Administrator Portal</h1>
            <div className="text-muted small">
              <i className="fas fa-user-shield mr-2"></i>Logged in as <strong>{user.name}</strong>
            </div>
          </div>
          <OrgSelect 
            organizations={organizations} 
            fetchOrganizations={fetchOrganizations}
            onSelectOrg={(org) => setSelectedOrg(org)}
          />
        </div>
      )}
    </div>
  );
};

export default AdminPortal;
